import { push } from "redux-first-history";
import * as authApi from "api/endpoints/auth";
import * as usersApi from "api/endpoints/users";
import { createSlice, createSliceSelector } from "../factory";
import { resetApp } from "./app";
import findError from "utils/findError";
import { setBaseUrl, setupTokenInterceptor } from "api/interceptors";
import getBaseUrl from "utils/getBaseUrl";

const name = "authPages";

const initialState = {
  loginDetails: null
};

const slice = createSlice(name, initialState);

export default slice.reducer;

/* Selectors */

const createSelector = createSliceSelector(name);

export const selectLoginDetails = createSelector((state) => {
  return state.loginDetails;
});

/* Actions */
const { update } = slice.actions;

export function logIn(email, password, redirectUrl) {
  return async function (dispatch) {
    try {
      const data = { email, password };
      const payload = { loginDetails: data };
      dispatch(update(payload));
      const result = await authApi.signIn(email.toLowerCase(), password);
      dispatch(push(redirectUrl || navigateUser(result)));
    } catch (err) {
      if (err.name === "UserNotConfirmedException") {
        dispatch(resendOTP(email.toLowerCase()));
        dispatch(push("/sign-up?verifyOtp"));
      }
      return { success: false, message: findError(err.name) };
    }
  };
}

export const recoverPassword = (email) => {
  return async function () {
    await authApi.forgotPassword(email.toLowerCase());
  };
};

export const forgotPasswordSubmit = (data) => {
  return async function () {
    const { code, password, email } = data;
    await authApi.forgotPasswordSubmit(email.toLowerCase(), code, password);
  };
};

export const signUp = (data) => {
  return async function (dispatch) {
    const attributes = {
      email: data.companyEmail.toLowerCase(),
      "custom:firstName": data.firstName,
      "custom:lastName": data.lastName,
      "custom:userType": data.userType,
      "custom:userRole": data.userRole,
      "custom:companyName": data.companyName
    };

    await authApi.signUp(data.companyEmail.toLowerCase(), data.password, attributes);
  };
};

export const resendOTP = (email) => {
  return async function () {
    return authApi.resendSignUp(email.toLowerCase());
  };
};

const registrationEnvironment = "sandbox";

export const register = (formData, otp, loginData) => {
  return async function (dispatch) {
    const email = formData?.companyEmail || loginData.email;
    const password = formData?.password || loginData.password;
    await authApi.confirmSignUp(email.toLowerCase(), otp);
    const result = await authApi.signIn(email, password);
    setupTokenInterceptor(result.signInUserSession);
    setBaseUrl(getBaseUrl(registrationEnvironment));
    const userDetails = formData !== null ? formData : getAwsCognitoData(result);
    await dispatch(createUser(userDetails));
    dispatch(push("/system-level-settings/access-administration"));
  };
};

export const signOut = () => {
  return async function (dispatch) {
    const payload = { signInDetails: null };
    dispatch(resetApp());
    return authApi.signOut().then(function () {
      dispatch(update(payload));
    });
  };
};

export const createUser = (data) => {
  return async function () {
    return await usersApi.put(data);
  };
};

//util helper function
function navigateUser(result) {
  const userType = result.attributes["custom:userType"];
  return userType === "D" ? "/system-level-settings/access-administration" : "/";
}

function getAwsCognitoData(result) {
  const userData = result.attributes;
  const signinData = {
    firstName: userData["custom:firstName"],
    lastName: userData["custom:lastName"],
    companyEmail: userData.email,
    companyName: userData["custom:companyName"],
    phoneNumber: "",
    userRole: userData["custom:userRole"],
    isMarketingEmailEnabled: true,
    userType: userData["custom:userType"]
  };
  return signinData;
}
